import { jsxs as $, jsx as o, Fragment as H } from "react/jsx-runtime";
import r, { useState as j, Children as R, useEffect as J } from "react";
import { m as k } from "../chunks/breakpoints.907eaecd.js";
import { styled as i, css as c } from "styled-components";
import { R as K } from "../chunks/Description.be3b00d1.js";
import { _ as L, a as E, j as V } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import { RangoTag as Q, TagType as U } from "./Tag.js";
import { R as W, I as S } from "../chunks/index.cff5baaf.js";
const X = i.div.withConfig({
  displayName: "Container",
  componentId: "sc-1vbwqj3-0"
})(["*{margin:0;padding:0;}flex-direction:column;align-items:flex-start;padding-left:var(--spacing-2x);"]), Y = i.div.withConfig({
  displayName: "Description",
  componentId: "sc-1vbwqj3-1"
})(["margin-bottom:var(--spacing-1x);"]), Z = r.forwardRef(({
  description: e = "",
  children: n,
  onClick: m,
  ...g
}, d) => {
  const [h, C] = j(null), p = (u, t) => {
    C(t), m && m(u);
  };
  return /* @__PURE__ */ $(X, { ref: d, ...g, children: [
    /* @__PURE__ */ o(Y, { children: /* @__PURE__ */ o(K, { children: e }) }),
    (() => R.map(n, (u) => {
      const t = u.props, a = t.index === h;
      return [r.cloneElement(u, {
        ...t,
        onClick: (x) => p(x, t.index),
        selected: a
      })];
    }))()
  ] });
});
Z.displayName = "RangoCategoryMenu";
i.div.withConfig({
  displayName: "Container",
  componentId: "sc-1jzbxsm-0"
})(["display:flex;flex-direction:row;align-items:start;width:100%;"]);
const ee = i.div.withConfig({
  displayName: "Content",
  componentId: "sc-1jzbxsm-1"
})(["display:flex;align-items:center;height:var(--size-6x);width:100%;"]);
i.div.withConfig({
  displayName: "IconContainer",
  componentId: "sc-1jzbxsm-2"
})(["margin-right:var(--spacing-1x);"]);
const ne = i.span.withConfig({
  displayName: "Label",
  componentId: "sc-1jzbxsm-3"
})(["", " color:var(", ");position:relative;cursor:pointer;z-index:1;", " ", ""], L, ({
  $inverse: e
}) => e ? "--inverse-label-color" : "--text-label-color", ({
  selected: e
}) => !e && c`
      &::before {
        content: '';
        position: absolute;
        left: calc(var(--spacing-1x) * -1);
        right: calc(var(--spacing-1x) * -1);
        height: var(--size-4x);
        bottom: -8px;
        border-radius: var(--border-radius-sm);
        z-index: -1;

        transition-property: background-color, opacity;
        transition-timing-function: var(--curve-productive-exit);
        transition-duration: var(--duration-fast-02);
      }

      &:hover::before {
        ${E}
        transition-timing-function: var(--curve-productive-entrance);
      }
    `, ({
  selected: e,
  $inverse: n
}) => e && `
    ${V}
    color: var(${n ? "--inverse-label-color" : "--selected-label-color"});
    
    &:before {
      content: '• ';
      position: absolute;
      left: -12px;
    `), te = r.forwardRef(({
  selected: e = !1,
  inverse: n = !1,
  as: m = "div",
  label: g = "",
  onItemClick: d,
  ...h
}, C) => {
  const [p, v] = r.useState(e);
  return r.useEffect(() => {
    v(!1);
  }, []), r.useEffect(() => {
    v(e);
  }, [e]), /* @__PURE__ */ o(ee, { ...h, ref: C, as: m, "data-testid": "rango-item-menu", onClick: (t) => {
    v(!p), d && d(t, h.index, !p);
  }, children: /* @__PURE__ */ o(ne, { $inverse: n, selected: p, children: g }) });
});
te.displayName = "RangoItemMenu";
const ie = i.div.withConfig({
  displayName: "Container",
  componentId: "sc-e9bly2-0"
})(["display:flex;flex-direction:column;align-items:start;width:100%;"]), oe = i.div.withConfig({
  displayName: "ChildrenContainer",
  componentId: "sc-e9bly2-1"
})(["display:none;flex-direction:column;padding-left:var(--spacing-3x);& > *{margin-left:var(--spacing-2x);}", ""], ({
  selected: e
}) => e && c`
      display: flex;
    `), re = i.div.withConfig({
  displayName: "Content",
  componentId: "sc-e9bly2-2"
})(["display:flex;align-items:center;"]), ae = i.div.withConfig({
  displayName: "IconContainer",
  componentId: "sc-e9bly2-3"
})(["margin-right:var(--spacing-1x);"]), _ = i.span.withConfig({
  displayName: "Label",
  componentId: "sc-e9bly2-4"
})(["", " max-width:", ";overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;color:var( ", " );"], L, ({
  $hasTag: e
}) => e ? "127px" : "183px", ({
  $inverse: e
}) => e ? "--inverse-label-color" : "--text-label-color"), se = i.div.withConfig({
  displayName: "ItemMenuContent",
  componentId: "sc-e9bly2-5"
})(["display:flex;align-items:center;justify-content:space-between;width:100%;", ""], ({
  selected: e,
  type: n
}) => !e && c`
      &::before {
        content: "";
        position: absolute;
        left: calc(var(--spacing-1x) * ${n === "Vertical" ? "2" : "-1"});
        right: calc(var(--spacing-1x) * ${n === "Vertical" ? "2" : "-1"});
        height: var(--size-5x);
        border-radius: var(--border-radius-sm);
        z-index: -1;

        transition-property: background-color, opacity;
        transition-timing-function: var(--curve-productive-exit);
        transition-duration: var(--duration-fast-02);
      }

      &:hover::before {
        ${E}
        transition-timing-function: var(--curve-productive-entrance);
      }
    `), le = i.div.withConfig({
  displayName: "Tag",
  componentId: "sc-e9bly2-6"
})(["margin-left:var(--spacing-1x);"]), ce = i.div.withConfig({
  displayName: "ItemMenuContainer",
  componentId: "sc-e9bly2-7"
})(["height:var(--size-6x);align-items:center;justify-content:space-between;min-width:max-content;", " cursor:pointer;position:relative;z-index:1;", " ", " ", ""], ({
  type: e
}) => e === "Vertical" && "padding: 0 var(--spacing-3x);", ({
  selected: e,
  type: n,
  $inverse: m
}) => e && n === "Vertical" && c`
      &:before {
        content: "";
        position: absolute;
        background-color: var(
          ${m ? "--inverse-bg-color" : "--elements-bg-color-04"}
        );
        width: 6px;
        height: 100%;
        bottom: 0;
        left: 0;
        border-radius: 0px var(--border-radius-xs) var(--border-radius-xs) 0px;
      }
    `, ({
  type: e
}) => e === "Vertical" ? c`
          display: flex;
          width: calc(100% - var(--spacing-6x));
        ` : c`
          display: inline-flex;

          ${k.md(c`
            display: flex;
            width: 100%;
          `)}
        `, ({
  selected: e,
  $inverse: n
}) => e && c`
      ${_} {
        ${V}
        color: var(${n ? "--inverse-label-color" : "--selected-label-color"});
      }
    `), z = i(W).withConfig({
  displayName: "Icon",
  componentId: "sc-e9bly2-8"
})(["", ""], ({
  selected: e,
  inverse: n
}) => e && c`
      color: var(${n ? "--inverse-icon-color" : "--selected-icon-color"});
    `), de = i.div.withConfig({
  displayName: "ArrowContainer",
  componentId: "sc-e9bly2-9"
})(["margin-left:var(--spacing-1x);"]), pe = r.forwardRef(({
  itemSelected: e = !1,
  showSubMenu: n = !1,
  showIcon: m = !1,
  showTag: g = !1,
  inverse: d = !1,
  as: h = "div",
  icon: C,
  label: p = "",
  tag: v = "",
  type: u = "Vertical",
  children: t,
  onSubItemClick: a,
  onSubItemChildClick: x,
  ...b
}, y) => {
  const [f, w] = r.useState(e), [D, T] = r.useState(() => {
    let s = null;
    return r.Children.forEach(t, (l) => {
      l.props.selected && (s = l.props.index);
    }), s;
  });
  r.useEffect(() => {
    w(e);
  }, [e]);
  const P = (s) => {
    w(!f), a && a(s, b.index, !f);
  }, q = (s, l, I, N) => {
    T(l), x && x(s, l, I), N && N(s, l, I);
  }, A = () => r.Children.map(t, (s) => {
    const l = s.props, I = l.index === D, N = l.onItemClick;
    return [r.cloneElement(s, {
      ...l,
      onItemClick: (O, B, G) => {
        q(O, B, G, N);
      },
      selected: I
    })];
  }), F = () => /* @__PURE__ */ $(re, { children: [
    m && /* @__PURE__ */ o(ae, { children: /* @__PURE__ */ o(z, { icon: C, size: S.SM, selected: f, inverse: d }) }),
    /* @__PURE__ */ o(_, { title: p, $inverse: d, $hasTag: g, children: p }),
    g && /* @__PURE__ */ o(le, { children: /* @__PURE__ */ o(Q, { type: U.Positive, children: v }) })
  ] }), M = (s, l) => /* @__PURE__ */ o(ce, { $inverse: d, selected: f, type: u, ...s, ref: l, as: h, onClick: P, "data-testid": "rango-list-menu-item", children: /* @__PURE__ */ $(se, { selected: f, type: u, children: [
    F(),
    n && /* @__PURE__ */ o(de, { children: /* @__PURE__ */ o(z, { inverse: d, selected: f, icon: f ? "DropdownCloseLine" : "DropdownOpenLine", size: S.SM }) })
  ] }) });
  return /* @__PURE__ */ o(H, { children: t ? /* @__PURE__ */ $(ie, { "data-testid": "rango-list-menu-item-container", ref: y, ...b, children: [
    M(),
    /* @__PURE__ */ o(oe, { "data-testid": "rango-list-menu-item-childrens", selected: f, children: A() })
  ] }) : M(b, y) });
});
pe.displayName = "RangoListItemMenu";
const me = i.div.withConfig({
  displayName: "Container",
  componentId: "sc-noed43-0"
})(["justify-content:center;align-items:flex-start;", ""], ({
  type: e
}) => e === "Vertical" ? c`
          width: 100%;
          display: flex;
          flex-direction: column;
        ` : c`
          display: inline-flex;
          flex-direction: row;
          gap: var(--spacing-3x);

          ${k.md(c`
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: var(--spacing-1_5x);

            & > * {
              width: 100%;
            }
          `)}
        `), fe = r.forwardRef(({
  type: e,
  children: n,
  as: m = "div",
  onClickChild: g,
  ...d
}, h) => {
  const [C, p] = j(null);
  J(() => {
    R.forEach(n, (t) => {
      t.props.itemSelected && p(t.props.index);
    });
  }, [n]);
  const v = (t, a, x, b) => {
    p(a), b && b(t, a, x), g && g(t, a, x);
  };
  return /* @__PURE__ */ o(me, { as: m, type: e, ref: h, "data-testid": "rango-list-menu", ...d, children: (() => R.map(n, (t) => {
    const a = t.props, x = a.index == C, b = a.onSubItemClick;
    return [r.cloneElement(t, {
      ...a,
      onSubItemClick: (y, f, w) => v(y, f, w, b),
      itemSelected: x
    })];
  }))() });
});
fe.displayName = "RangoListMenu";
export {
  Z as RangoCategoryMenu,
  te as RangoItemMenu,
  pe as RangoListItemMenu,
  fe as RangoListMenu
};
